import React from 'react'
import { useGlobalActivityTracker } from '../../hooks/useGlobalActivityTracker'
import { WorkoutConfirmationView } from '../../views/Activities/components/WorkoutConfirmationView/WorkoutConfirmationView'
import YumDrawer from '../YumDrawer/YumDrawer'
import { WorkoutType } from '../../plugins/ActivityTrackerPlugin'

/**
 * Global workout confirmation modal that appears regardless of which view is active
 * This ensures workout confirmations are never lost
 */
export const GlobalWorkoutConfirmationModal: React.FC = () => {
  const { confirmationData, isConfirmationRequired, confirmWorkout, discardWorkout } = useGlobalActivityTracker()

  // Handle workout confirmation save
  const handleConfirmationSave = async (updatedData: { title: string; type: WorkoutType }) => {
    try {
      console.log('✅ GlobalWorkoutConfirmationModal: Confirming workout with:', {
        title: updatedData.title,
        type: updatedData.type,
      })

      await confirmWorkout(updatedData.title, updatedData.type)
      console.log('✅ GlobalWorkoutConfirmationModal: Workout confirmed successfully')
    } catch (error) {
      console.error('❌ GlobalWorkoutConfirmationModal: Failed to save workout confirmation:', error)
    }
  }

  // Handle workout confirmation discard
  const handleConfirmationDiscard = async () => {
    try {
      console.log('🗑️ GlobalWorkoutConfirmationModal: Discarding workout')
      await discardWorkout()
      console.log('✅ GlobalWorkoutConfirmationModal: Workout discarded successfully')
    } catch (error) {
      console.error('❌ GlobalWorkoutConfirmationModal: Failed to discard workout confirmation:', error)
    }
  }

  // Don't render if no confirmation is required
  if (!isConfirmationRequired || !confirmationData) {
    console.log(
      '🔧 GlobalWorkoutConfirmationModal: Not rendering - isConfirmationRequired:',
      isConfirmationRequired,
      'confirmationData:',
      confirmationData,
    )
    return null
  }

  console.log('🔧 GlobalWorkoutConfirmationModal: Rendering confirmation modal with data:', confirmationData)

  return (
    <YumDrawer
      disableSwipeToClose={true}
      style={{ position: 'relative' }}
      open={isConfirmationRequired}
      onClose={handleConfirmationDiscard}
      onOpen={() => {}}
      PaperProps={{
        style: {
          background: 'white',
          borderTopLeftRadius: '30px',
          borderTopRightRadius: '30px',
          padding: '20px',
        },
      }}
    >
      <WorkoutConfirmationView
        confirmationData={{
          title: confirmationData.title,
          type: confirmationData.type,
          duration: confirmationData.duration,
          distance: confirmationData.distance,
          calories: confirmationData.calories,
          steps: confirmationData.steps,
          startTime: new Date(confirmationData.startTime),
          endTime: new Date(confirmationData.endTime),
          locations: confirmationData.locations,
        }}
        onSave={handleConfirmationSave}
        onDiscard={handleConfirmationDiscard}
      />
    </YumDrawer>
  )
}
